import { ValueType } from '../../../../../../types/_campaigns/campaignBuilder.js';

export type SavedGoal = {
  goalValue: string | null;
  metricLabel: string;
  valueType: ValueType;
  metricId: number;
};

export type Goal = {
  label: string;
  name: string;
  id: number;
  valueType: ValueType;
  softDeleted?: boolean;
};

export type GoalOption = Goal & {
  groupLabel?: string;
};

export type PreparedGoal = {
  goalLabel: string | null;
  goalValue: number | null;
  goalValueType: ValueType | null;
  isLocked: boolean;
};

export enum GOAL_GROUPS {
  CAMPAIGNS_GOALS = 'campaignsGoals',
  ADSERVER_GOALS = 'adServer',
  ANALYTICS_GOALS = 'analytics',
  CUSTOM_METRICS = 'dataImportHub',
}
